import React from 'react';
import styled from 'styled-components';
import { RatesAndTermsPageProps } from './RatesAndTermsPage.model';
import { RatesAndTermsPageStyle } from './RatesAndTermsPage.style';

const RatesAndTermsPage = styled(({ className }: RatesAndTermsPageProps) => {
  return (
    <div className={className}>
      <div className="header-section">
        <div className="subtitle">Financing Details</div>
        <h1 className="title">Rates &amp; Terms</h1>
      </div>

      <div className="content-section">
        <p>
          <strong>Loan Amount:</strong> $50 – $20,000*
        </p>
        <p>
          <strong>Loan Term:</strong> 3 to 72 months*
        </p>
        <p>
          <strong>Annual Percentage Rate:</strong> 0-35.99% APR*
        </p>
        <p>
          <strong>A payment is due at checkout.</strong>
        </p>
        <p>
          <strong>The minimum loan amount may be higher at some merchants.</strong>
        </p>
        <p>
          <strong>*</strong> Loan rates, terms, and amounts are lower in some states due to legal requirements. Colorado residents and merchant locations:
          0-35.99% APR for loans of $1,000 or less; 0-20.99% APR for loans over $1,000 but not more than $3,000; 0-14.99% APR for loans over $3,000. Connecticut
          residents and locations: 0-35.99% APR for loans less than $5,000; 0-24.99% APR for loans from $5,000 to $50,000. A customer cannot have more than
          $50,000 in principal at any one time. (lic. #SLC-1760582 & SLC-BCH- 1844702). Hawaii residents and locations: maximum loan amount of $1,500; 3-month
          plans not available if loan is more than $500. Iowa residents and locations: 0-20.99% APR. Maine residents and locations: 0-29.99% APR for loans of
          $2,000 or less; 0-23.99% for loans more than $2,000 to $4,000; 0- 17.99% APR for loans more than $4,000. Massachusetts residents and locations:
          0-17.99% APR for loans less than $1,000; 0-22.99% APR for loans from $1,000 to $6,000; 0-19.99% for loans over $6,000. Maryland residents and merchant
          locations: 0-23.99% APR. Minnesota: 9-month or longer terms for loans of $1,300 or less. New Hampshire residents and locations: A customer cannot have
          more than $10,000 principal at any one time. New York residents and merchant locations: 0-24.99% APR.
        </p>
        <p>
          <strong>Application and Eligibility:</strong> Subject to approval based on creditworthiness. Applicants must be 18 or older, as required by state law
          and have a valid email address, mobile phone number, and street or AFO/APO address. A bank-issued debit card is required for the payment due at
          checkout. If approved, the rates, terms, and loan amounts offered will fall within the ranges provided above.{' '}
          <strong>
            The largest loan amounts and longest terms are not available at all merchants. Only the most creditworthy applicants qualify for the lowest rates,
            largest loan amounts, and longest terms. 0% APR plans are not available at all merchants.
          </strong>{' '}
          Loans are not available in or to residents of Vermont, West Virginia, or US territories.
        </p>
        <p>
          <strong>Deferred Interest Promotion:</strong> A deferred interest option allows borrowers at participating merchants only to avoid paying interest if
          they prepay the amount financed in full within 1 month of the date of the agreement. If borrowers do not prepay the amount financed in full by that
          time, then they will be responsible for paying interest as it accrues.
        </p>
        <p>
          <strong>Loan Example:</strong> A $580 purchase with a 33% APR, $116 down payment, and 12-month term would have monthly payments of $45.92 and a total
          cost of $667.07. A $381.68 purchase with 0% APR, $114.50 down payment and a 3-month term would have monthly payments of $89.06 and a total cost of
          $381.68. Actual terms may vary.
        </p>
        <p>Account openings and payment activity may be reported to a major credit bureau.</p>
        <p>
          Connecticut, Minnesota, New Jersey, and New York Consumers: If a loan is in the healthcare category, Sunbit will not report account opening, payment
          activities, or any portion of the debt to a consumer reporting agency. If any part of a loan in the healthcare category has been reported by Sunbit to
          a consumer reporting agency, the portion reported is void.
        </p>
        <p>Loans are made by Transportation Alliance Bank, Inc., dba TAB Bank, which determines qualifications for and terms of credit.</p>
      </div>
    </div>
  );
})`
  ${RatesAndTermsPageStyle}
`;

export default RatesAndTermsPage;
